module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid login",
    style: (_vm.colorbackground)
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 mx-auto login-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "style-scope page-auth-login",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('h1', {
    staticClass: "logo-name style-scope page-auth-login"
  }, [_c('a', {
    attrs: {
      "href": "https://royalpag.com"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center text-default-gray",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto",
      "margin-bottom": "20px !important"
    }
  }, [_vm._v("\n            Bem-vindo ao RoyalPag\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-default-gray pt-2",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto"
    }
  }, [_vm._v("Desenhado e criado para proporcionar agilidade e segurança para você.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-default-gray",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto",
      "margin-bottom": "0px !important"
    }
  }, [_vm._v("Entrar para obter!")]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "well top25",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login),
      expression: "login"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "login",
      "type": "text",
      "autocomplete": "username",
      "required": "",
      "autofocus": "",
      "placeholder": "Login"
    },
    domProps: {
      "value": (_vm.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senha),
      expression: "senha"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "senha",
      "type": "password",
      "autocomplete": "current-password",
      "required": "",
      "autofocus": "",
      "placeholder": "Senha"
    },
    domProps: {
      "value": (_vm.senha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senha = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block mb-3",
    style: (_vm.color),
    attrs: {
      "type": "submit",
      "value": "Entrar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "float-left",
    attrs: {
      "to": "/forgotPassword",
      "exact": ""
    }
  }, [_vm._v("Esqueceu a senha? ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "float-right sign-up"
  }, [_vm._v("Novo?  "), _c('router-link', {
    attrs: {
      "to": "/register",
      "exact": ""
    }
  }, [_vm._v("Cadastrar")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-sm-10 pt-2 pl-0"
  }, [_c('router-link', {
    staticClass: "float-left",
    attrs: {
      "to": "/verificar",
      "exact": ""
    }
  }, [_vm._v("Verificar código recebido?")])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalTelefone",
    staticClass: "modal",
    staticStyle: {
      "min-width": "max-content !important",
      "display": "none"
    },
    attrs: {
      "id": "modalConfirmTelefone",
      "title": "Atualização do telefone"
    },
    on: {
      "hide": _vm.closeModalTelefone
    },
    model: {
      value: (_vm.showModalTelefone),
      callback: function($$v) {
        _vm.showModalTelefone = $$v
      },
      expression: "showModalTelefone"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "min-width": "max-content !important"
    },
    attrs: {
      "role": "form"
    }
  })]), _vm._v(" "), _c('b-modal', {
    ref: "modalTelefone",
    staticClass: "pb-0",
    staticStyle: {
      "min-width": "max-content !important",
      "display": "inline-table"
    },
    attrs: {
      "id": "modalConfirmTelefone",
      "title": "Atualização do telefone",
      "role": "form",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showModalTelefone),
      callback: function($$v) {
        _vm.showModalTelefone = $$v
      },
      expression: "showModalTelefone"
    }
  }, [_c('div', {
    staticClass: "align-content-center content p-0",
    staticStyle: {
      "min-width": "max-content !important"
    }
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "asterisco"
  }, [_c('label', {
    staticClass: "font-label text-default-gray"
  }, [_vm._v("Confirme seu número de celular, um SMS com código será enviado")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmarCelular.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('vue-phone-number-input', {
    attrs: {
      "preferred-countries": ['BR', 'PT'],
      "default-country-code": 'BR',
      "translations": _vm.translations,
      "maxlength": "18"
    },
    on: {
      "update": _vm.onUpdate
    },
    model: {
      value: (_vm.telefone),
      callback: function($$v) {
        _vm.telefone = $$v
      },
      expression: "telefone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-bottom-0"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "name": "submit",
      "type": "submit"
    }
  }, [_vm._v("Enviar SMS")])])])])])])])])])])])], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f2d70b9","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/index.vue
// module id = k+E3
// module chunks = 36